// extracted by mini-css-extract-plugin
export var container = "_d4-0";
export var infoIcon = "_d4-2";
export var titleRowCol = "_d4-1";